module.exports = __webpack_public_path__ + "img/img_honor10_us@3x.f7255810.png";